export const getOptionColor = (title: string, positionIdx: number): string => {
  if (title === "Da" || title === "Yes") {
    return "#22c55e";
  }

  if (title === "Nu" || title === "No") {
    return "#ef4444";
  }

  if (title === "Indecis" || title === "Undecided") {
    return "#eab308";
  }

  const colors = ["#295FE6", "#007CF7", "#8E62EF", "#E02EE5", "#FF9432"] as const;

  // const charCodeSum =
  //   title
  //     .split("")
  //     .map((char) => char.charCodeAt(0))
  //     .reduce((sum, charCode) => sum + charCode, 0) + positionIdx;
  const charCodeSum = positionIdx;

  return colors[charCodeSum % colors.length] || colors[0];
};
